import { Pipe, PipeTransform } from '@angular/core';

const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/gi;

@Pipe({
    name: 'linkify',
    standalone: true,
})
export class LinkifyPipe implements PipeTransform {
    transform(value: any): any {
        return value?.replace(urlRegex, (url) => {
            const label = url;
            url = url.startsWith('http') ? url : `http://${url}`;

            return `<a href="${url}" class="linkify" target="_blank">${label}</a>`;
        });
    }
}
